/**
 * «Докручивающиеся» числа (Cosmic-проход 2026-08-21): баланс и токены
 * плавно доезжают до нового значения вместо мгновенной подмены.
 * Под prefers-reduced-motion значение просто подставляется.
 */
import { useEffect, useRef, useState } from 'react';

export function useCountUp(target: number, durationMs = 700): number {
  const [value, setValue] = useState(target);
  const fromRef = useRef(target);

  useEffect(() => {
    const from = fromRef.current;
    if (from === target) return undefined;

    if (globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      fromRef.current = target;
      setValue(target);
      return undefined;
    }

    const start = performance.now();
    let raf = 0;
    const tick = (now: number): void => {
      const progress = Math.min(1, (now - start) / durationMs);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(from + (target - from) * eased);
      if (progress < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        fromRef.current = target;
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, durationMs]);

  return value;
}
